import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import memberStore from './memberStore'
import reserveStore from './reserveStore'
import myInfoStore from './myInfoStore'
import redirectUrlStore from './redirectUrlStore'

export default createStore({
    plugins: [
        createPersistedState({
            paths: ['memberStore', 'reserveStore','myInfoStore', 'redirectUrlStore'],
            // memCi/memDi(연계정보)는 회원가입 진행 중에만 메모리에 필요한 값이라 localStorage에는 절대 남기지 않음
            reducer: (state) => ({
                memberStore: { ...state.memberStore, memCi: '', memDi: '' },
                reserveStore: state.reserveStore,
                myInfoStore: { ...state.myInfoStore, memCi: '', memDi: '' },
                redirectUrlStore: state.redirectUrlStore,
            })
        })
    ],
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
    },
    modules: {
        /**
         * 회원가입
         */        
        memberStore: memberStore,
        reserveStore: reserveStore,
        myInfoStore: myInfoStore,
        redirectUrlStore: redirectUrlStore,
    }
})
